/** Shows the top-10 run history stored in localStorage. */
export function LeaderboardScreen({ leaderboard, totalGold, onBack }) {
  const medals = ['🥇', '🥈', '🥉'];

  return (
    <div className="overlay leaderboard-screen">
      <button className="back-btn" onClick={onBack}>← Back</button>
      <h1>🏆 Leaderboard</h1>
      <p className="lb-total-gold">💰 {totalGold} Total Gold in Bank</p>

      {leaderboard.length === 0 ? (
        <p style={{ color: '#4a6a8a', marginTop: '1rem' }}>
          No runs yet — play a game first!
        </p>
      ) : (
        <table className="lb-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Distance</th>
              <th>Level</th>
              <th>Kills</th>
              <th>Gold</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {leaderboard.map((run, i) => (
              <tr
                key={i}
                className={
                  i === 0 ? 'lb-row--gold'
                  : i === 1 ? 'lb-row--silver'
                  : i === 2 ? 'lb-row--bronze'
                  : ''
                }
              >
                <td className="lb-rank">{medals[i] ?? i + 1}</td>
                <td>{run.score.toLocaleString()} pts</td>
                <td>Lv {run.level}</td>
                <td>⚔️ {run.kills}</td>
                <td>💰 {run.gold}</td>
                <td>{run.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
